// Visually hides text while keeping it accessible to screen readers.
// Used for cells that display icons or are empty, so screen readers
// can announce meaningful text (e.g. "Yes"/"No", "Empty") instead of silence.
export const VISUALLY_HIDDEN_STYLE = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  whiteSpace: 'nowrap',
  border: 0,
};
